// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";

import {
  addGarfield,
  sendPageView,
  initialiseClientId,
  sendBounceEvent,
  sendTimeSpent,
} from "./src/utils/garfieldHelpers";

// custom CSS styles
export const shouldUpdateScroll = ({
  routerProps: { location },
}) => {
  // list of routes for the scroll-to-top-hook
  if (location.state?.from === "tabs") {
    return false;
  }
};

export const onClientEntry = () => {

  window["timeStart"]=0; // for calc. time spent
  window["isFirstLoad"] = true; // for calc. time spent
  addGarfield();
  initialiseClientId();
  sendPageView();
};

export const onRouteUpdate = ({
  prevLocation,
  location,
}) => {
  if(window?.isFirstLoad === false)
  {
    const timeSpent = Date.now() - window?.timeStart;
    const metaData = {
      tags : {
        "t0" : timeSpent,
        "t1" : prevLocation?.href,
      }
    }
    sendTimeSpent(metaData);
    if(timeSpent < 10*1000) sendBounceEvent(metaData);
  }
  window["isFirstLoad"] = false;
  window["timeStart"] = Date.now();
  if (prevLocation && prevLocation.href !== location.href) {
    sendPageView();
  }
};
